import { render } from "./portal-upload-image.vue?vue&type=template&id=7d0bbb92"
import script from "./portal-upload-image.vue?vue&type=script&lang=js"
export * from "./portal-upload-image.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__